import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './i18n';
import './App.css';
import { AuthProvider } from './context/AuthContext';
import { CurrencyProvider } from './context/CurrencyContext';
import { ConfigProvider } from './config';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import EmailVerifyBanner from './components/EmailVerifyBanner';
import InstallAppBanner from './components/InstallAppBanner';
import { ProtectedRoute } from './pages/ProtectedRoute';
import { Toaster } from './components/ui/sonner';

// Pages
import Home from './pages/Home';
import Guides from './pages/Guides';
import GuideDetailSimple from './pages/GuideDetailSimple';
import BecomeGuide from './pages/BecomeGuide';
import Dashboard from './pages/Dashboard';
import Account from './pages/Account';
import MonPasseport from './pages/MonPasseport';
import AdminDashboard from './pages/AdminDashboard';
import GuideDashboard from './pages/GuideDashboard';
import Terms from './pages/Terms';
import CGV from './pages/CGV';
import Privacy from './pages/Privacy';
import DeleteAccount from './pages/DeleteAccount';
import About from './pages/About';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import VerifyEmail from './pages/VerifyEmail';
import AdminPortal from './pages/AdminPortal';
import BookingFlow from './pages/BookingFlow';
import BookingSuccess from './pages/BookingSuccess';
import BookingCancel from './pages/BookingCancel';
import Activities from './pages/Activities';
import ActivityDetail from './pages/ActivityDetail';
import BookingActivity from './pages/BookingActivity';

function AppRouter() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/admin-portal" element={<AdminPortal />} />
        <Route path="/guides" element={<Guides />} />
        <Route path="/hosts" element={<Guides />} />
        <Route path="/guides/:guideId" element={<GuideDetailSimple />} />
        <Route path="/activities" element={<Activities />} />
        <Route path="/activities/:activityId" element={<ActivityDetail />} />
        <Route path="/become-guide" element={<BecomeGuide />} />
        <Route path="/become-host" element={<BecomeGuide />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/cgv" element={<CGV />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
        <Route path="/about" element={<About />} />
        
        {/* Protected Routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        {/* Mon compte : commun aux voyageurs et aux guides */}
        <Route
          path="/account"
          element={
            <ProtectedRoute>
              <Account />
            </ProtectedRoute>
          }
        />
        <Route
          path="/passeport"
          element={
            <ProtectedRoute>
              <MonPasseport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/*"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/guide/*"
          element={
            <ProtectedRoute allowedRoles={['guide', 'admin']}>
              <GuideDashboard />
            </ProtectedRoute>
          }
        />
        
        {/* Booking Routes */}
        <Route
          path="/booking/:guideId"
          element={
            <ProtectedRoute>
              <BookingFlow />
            </ProtectedRoute>
          }
        />
        <Route
          path="/booking-activity/:activityId"
          element={
            <ProtectedRoute>
              <BookingActivity />
            </ProtectedRoute>
          }
        />
        <Route path="/booking/success" element={<BookingSuccess />} />
        <Route path="/booking/cancel" element={<BookingCancel />} />
      </Routes>
      <Footer />
      <div className="fixed bottom-0 inset-x-0 z-40 flex flex-col">
        <InstallAppBanner />
        <EmailVerifyBanner />
      </div>
      <Toaster position="top-right" />
    </>
  );
}

function App() {
  return (
    <Router>
      <ConfigProvider>
        <CurrencyProvider>
          <AuthProvider>
            <AppRouter />
          </AuthProvider>
        </CurrencyProvider>
      </ConfigProvider>
    </Router>
  );
}

export default App;